import { createCRUDService } from './createCRUDService';
import { TALUKAS } from './api/endpoints';

// Create base CRUD service
const baseCRUD = createCRUDService(TALUKAS.BASE);

// Export service with districtId filter support
export const TalukaService = {
  ...baseCRUD,

  // Override getAll to support districtId filter
  getAll: async ({ page = 1, limit = 100, status = '', search = '', districtId = '' } = {}) => {
    const params = { page, limit };
    if (status) params.status = status;
    if (search) params.search = search;
    if (districtId) params.districtId = districtId;
    return baseCRUD.getAll(params);
  },
};

export default TalukaService;
